import CloseIcon from '@mui/icons-material/Close'
import {
  Alert,
  Box,
  Button,
  IconButton,
  Modal,
  Paper,
  Typography,
} from '@mui/material'

interface EmailLinkErrorProps {
  open: boolean
  onClose: () => void
  errorMessage: string
  emailAutosent: boolean
}

export function EmailLinkError({
  open,
  onClose,
  errorMessage,
  emailAutosent,
}: EmailLinkErrorProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='email-notification-modal'
      aria-describedby='email-notification-description'
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        pt: 5, // Top padding to position it near the top of the screen
      }}
    >
      <Paper
        elevation={6}
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: 500,
          p: 4,
          pt: 5,
          pb: 3,
          m: 2,
        }}
      >
        {/* Close (X) button in top right */}
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Alert message */}
        <Alert
          severity={emailAutosent ? 'warning' : 'error'}
          sx={{
            width: '100%',
            mb: 3,
            '& .MuiAlert-message': {
              fontSize: '1rem',
            },
          }}
        >
          <Typography variant='body1' component='div'>
            {errorMessage}
          </Typography>
        </Alert>

        {/* Close Window button */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button
            variant='contained'
            color='primary'
            onClick={onClose}
            sx={{ minWidth: 150 }}
          >
            OK
          </Button>
        </Box>
      </Paper>
    </Modal>
  )
}
